import Map from '@mui/icons-material/Map';
import { FixMe } from '@greenkub-fronts/shared/interface';
export function MapIcon(props: FixMe) {
  return <Map {...props} />;
}

export default MapIcon;
